export enum DateNames {
	DW_DATE = 'debtwarningDate',
	BO_DATE = 'boDate',
	DCF_DATE = 'dcfDate',
	VT_DATE = 'vtDate',
	LAST_BO_DATE = 'lastBODate',
	OBSOLETE_DATE = 'obsoleteDate',
	LAST_DISTRAINT_DATE = 'lastDistraintDate',
	LAST_COURT_DATE = 'lastCourtDate',
	MIGRATED_DATE = 'migratedDate',
	OBJECTION_DATE = 'objectionDate',
	INTEREST_STOP_DATE = 'interestStopDate',
	CLOSE_DATE = 'closeDate'
}

export enum DateFormats {
	DMYDateFormat = 'DD/MM/YYYY',
	StandardDateFromat = 'YYYY-MM-DD'
  }